import React, { useMemo } from 'react';

import Envelope from '@ast/magma/components/icon/icons/Envelope';

import {
  FieldInfoGroupFieldFragment as FieldInfoGroupField,
} from '@app/common/configurable-wizards/queries/queryTyping/all-fields';
import {
  FieldComponent,
  FieldLocator,
} from '@app/common/configurable-wizards/types';
import { isFieldInfoGroupField } from '@app/common/configurable-wizards/utils';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import { getMappedFields } from '../../utils/subFieldsMapper';

import styles from './EmailFieldListItem.pcss';

export const EmailFieldListItem: FieldComponent<FieldInfoGroupField> = ({ field }) => {
  const { t } = useUserSettingsTranslation();

  const fieldMeta = useMemo(
    () => getMappedFields(field.subFields),
    [field],
  );

  const emailAddress = fieldMeta.PrimaryEmail?.value;
  const isPrimary = fieldMeta.IsPrimary?.value;

  return (
    <div
      data-stable-name={`${isPrimary ? 'Primary' : 'Secondary'}EmailItem`}
      className={styles.listItem}
    >
      <span className={styles.icon}>
        <Envelope />
      </span>
      <div className={styles.details}>
        <div>{emailAddress}</div>
        {isPrimary && (
          <span className={styles.primary}>
            {t(
              'display-email-field-group-item.primary|User settings primary email label',
              'Primary email',
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export const DisplayEmailFieldInfoGroupItemLocator: FieldLocator = ({ field }) => (
  isFieldInfoGroupField(field) && field.id === 'EmailFieldGroup'
    ? EmailFieldListItem
    : undefined
);
